import React from 'react';
import { withNamespaces } from 'react-i18next';
import ErrorMessage from '../UI/ErrorMessage';
import { useStyles } from './styles';

const InvalidLink = ({ t }) => {
  const classes = useStyles();

  return (
    <div className={classes.invalidLink}>
      <i className="material-icons">error_outline</i>
      <ErrorMessage message={t('task:task:invalidLinkMessage')} />
    </div>
  );
};

export default withNamespaces('task')(InvalidLink);
